var _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgExpandedSelected(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 29,
    viewBox: "0 0 28 29",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 27,
    height: 27.1029,
    rx: 4.83333,
    fill: "#E8F0FD",
    stroke: "#1454B8"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 5.25,
    y: 7.90332,
    width: 5.25,
    height: 5.2693,
    rx: 1,
    stroke: "#1557BF",
    strokeWidth: 2
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 13.1251,
    y: 7.02539,
    width: 11.375,
    height: 1.75643,
    rx: 0.878217,
    fill: "#1557BF"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 13.1251,
    y: 15.8076,
    width: 11.375,
    height: 1.75643,
    rx: 0.878217,
    fill: "#1557BF"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 13.1251,
    y: 10.5381,
    width: 11.375,
    height: 1.75643,
    rx: 0.878217,
    fill: "#1557BF"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 13.1251,
    y: 19.3203,
    width: 11.375,
    height: 1.75643,
    rx: 0.878217,
    fill: "#1557BF"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 5.25,
    y: 16.335,
    width: 5.25,
    height: 5.2693,
    rx: 1,
    stroke: "#1557BF",
    strokeWidth: 2
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExpandedSelected);
export default __webpack_public_path__ + "static/media/expanded-selected.50a988ab4a0137fdab19de0aaab4ed2c.svg";
export { ForwardRef as ReactComponent };